"use client";

import React from "react";

export type UIOptionsContextType = {
  shouldUseResponsiveTypography: boolean;
};

export const UIOptionsContext = React.createContext<UIOptionsContextType>({
  shouldUseResponsiveTypography: false,
});

export const useUIOptions = () => React.useContext(UIOptionsContext);
